import type {
  RenDecorationComponent,
  RenDecorationMarketTemplate
} from '../../types'

export function formatMoney(amount: number | string | undefined | null): string {
  const num = Number(amount ?? 0)
  if (isNaN(num)) return '0.00'
  return num.toFixed(2)
}

export function componentPreviewLabel(component?: RenDecorationComponent | null): string {
  if (!component) return ''
  return component.title || component.type || '未命名组件'
}

export function templateThemeColor(template?: RenDecorationMarketTemplate | null): string {
  return template?.themeColor || '#5A46E0'
}

export function templateBackgroundColor(template?: RenDecorationMarketTemplate | null): string {
  return template?.backgroundColor || '#F3F5F7'
}

export function templateScopeLabel(template?: RenDecorationMarketTemplate | null): string {
  if (!template) return ''
  if (template.publicTemplate || template.scope === 'SYSTEM' || template.scope === 'PUBLIC') {
    return '系统预置'
  }
  return '租户自定义'
}

export function templateStatusLabel(template?: RenDecorationMarketTemplate | null): string {
  if (!template) return ''
  if (template.deleted || template.status === 'RECYCLED') {
    return '已放入回收站'
  }
  return template.status === 'DISABLED' ? '已下架' : '已上架'
}

export function formatTemplateDate(dateStr?: string | number | Date | null): string {
  if (!dateStr) return '-'
  try {
    const d = new Date(dateStr)
    if (isNaN(d.getTime())) return String(dateStr)
    const y = d.getFullYear()
    const m = String(d.getMonth() + 1).padStart(2, '0')
    const day = String(d.getDate()).padStart(2, '0')
    const h = String(d.getHours()).padStart(2, '0')
    const min = String(d.getMinutes()).padStart(2, '0')
    return `${y}-${m}-${day} ${h}:${min}`
  } catch {
    return String(dateStr)
  }
}
